/**
 * @typedef {"Select from the following..." | "Add as driver on policy." | "No longer resides in household."} EditHhmOption
 */

/**
 * @returns {EditHhmOption[]}
 */
const editHhmOptions = (age) => {
    return [
        "Select from the following...",
        ...(age >= 16 ? ["Add as driver on policy."] : []),
        "No longer resides in household.",
    ]

}

export default editHhmOptions